import Global from '../../js/constant.js'
import axios from 'axios'

const circles = {
  state: {
    circles: {},
    myCircles : null,
  },
  getters: {
    circles(state) { return state.circles },
    myCircles(state) { return state.myCircles }
  },
  mutations: {
    setCircles (state, value) {
      state.circles = value
    },
    setMyCircles(state, value) {
      state.myCircles = value
    },
  },
  actions: {
    async getCircles ({commit}, account) {
      let params = {}
      if (account) params['account_id'] = account.id
      await axios.post( Global.url.api_all_circles, params).then(res => {
        if (res.data.status == Global.api_status.success) {
          commit('setCircles', res.data.circles)
        }
      }).catch(error=>{
        console.dir(error)
      })
    },
    async getMyCircles ({commit}, account) {
      if (!account) return 
      await axios.post(Global.url.api_circle_members_search_by_account_id, { account_id: account.id })
      .then(res => {
        if (res.data.status == Global.api_status.success) {
          commit('setMyCircles', res.data.circle_members)
        }
      }).catch(error => {
        console.dir(error)
      })
    },
  },
  modules: {}
}
export default circles